import { Injectable } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {Subject} from 'rxjs/Subject';

@Injectable()
export class PreviousUrlService {

  private previousUrl : string = undefined;
  private currentUrl : string = undefined;
  private sendIds: any;
  private surveyTitle: string;
  private translationTitle: string;
  readonly titleChanges = new Subject<string>();

  constructor(public router : Router) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
  }

  public getPreviousUrl(){
    return this.previousUrl;
  }

  setIds(response: any) {
    this.sendIds = response;
  }

  getIds(): any {
    if (this.sendIds) {
      return this.sendIds;
    }
  }

  setSurveyTitle(response: string) {
    this.titleChanges.next(response);
    this.surveyTitle = response;
  }

  getSurveyTitle(): string {
    if (this.surveyTitle) {
      return this.surveyTitle;
    }
  }

  setTranslationTitle(response: string) {
    this.translationTitle = response;
  }

  getTranslationTitle(): string {
    if (this.translationTitle) {
      return this.translationTitle;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/previous-url.service.ts